module.exports = __webpack_public_path__ + "static/media/10.ed15f413.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/10.png
// module id = 1115
// module chunks = 0